module.exports = __webpack_public_path__ + "static/media/crazypaving.da68e9bf.jpg";